import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './HintQuestionItemSlider.css';

interface IHintQuestionItemSliderProps {
  text: string;
  onClick(text: string): void;
}

export const HintQuestionItemSlider: React.FC<IHintQuestionItemSliderProps> = ({ text, onClick }) => {
  return (
    <span className={styles['container']} onClick={() => onClick(text)}>
      <UIHeading5 color="text-main-default" whiteSpace="nowrap">
        {text}
      </UIHeading5>
    </span>
  );
};
